import React from "react";
import NewsletterPublishHub from "./publish/NewsletterPublishHub";

const NewsletterPubblicaTab = () => <NewsletterPublishHub />;

export default NewsletterPubblicaTab;
